import { AxiosResponse } from 'axios';

import API from '../Api';
import { getUserToken } from '../utils/login';
import { ContactInfo, EvChargingIssueInfo } from '../types/contactInfo';

export const postContactForm = async (
  contactInfo: ContactInfo,
  dataOwnerCustomerId: number,
  evChargingIssueInfo?: EvChargingIssueInfo,
): Promise<XMLHttpRequest> => {
  const { bearer, content } = getUserToken();

  const response: AxiosResponse<string> = await API({
    method: 'post',
    url: `/v1/contactForm/${dataOwnerCustomerId}`,
    headers: {
      Authorization: `Bearer ${bearer}`,
    },
    data: {
      contactInfo,
      content,
      evChargingIssueInfo,
    },
  });

  return response.request;
};

export const postBankAccount = async (contactInfo: ContactInfo, dataOwnerCustomerId: number): Promise<XMLHttpRequest> => {
  const { bearer, content } = getUserToken();

  const response: AxiosResponse<string> = await API({
    method: 'post',
    url: `/v1/bankAccount/${dataOwnerCustomerId}`,
    headers: {
      Authorization: `Bearer ${bearer}`,
    },
    data: {
      contactInfo,
      content,
    },
  });

  return response.request;
};
